@if (!m_dialogGetAsset) {
  <a color="warn" class="pull-left" routerLink="/editor/list" href="#">
    <mat-icon style="position: relative; top: 6px">chevron_left</mat-icon>
    {{'general.back' | transloco}}
  </a>
}
@if (loading) {
  <div>
    <app-loading [size]="'60px'" [style]="{'margin-top': '100px'}"></app-loading>
    <!-- <ngx-skeleton-loader
    count="1"
    animation="progress-dark"
    appearance="circle"
            [theme]="{
                'border-radius': '5px',
                'height': '140px',
                'width': '100%',
                'background-color': 'var(--background-color17)'
            }">
  </ngx-skeleton-loader> -->
</div>
} @else {
  <div
    class="templates-wrapper"
    infinite-scroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="scrollDistance"
    [infiniteScrollThrottle]="throttle"
    (scrolled)="moreTemplateCategories()">
    <div class="filter-wrapper">
      <mat-form-field class="form-element filterList" style="margin-left: 40px;">
        <mat-label>{{'placeholder.filterList' | transloco}}</mat-label>
        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter($event.target['value'])" name="SearchDualList" class="form-control" [(ngModel)]="filter"
          autocomplete="off"/>
          <a matSuffix aria-label="Clear" (click)="clearSelection()">
            <mat-icon>close</mat-icon>
          </a>
        </mat-form-field>
      </div>
      @for (templates of currentTemplates; track templates; let sectionIndex = $index) {
        <div class="panel-wrapper" [style.--section-index]="sectionIndex">
          <div class="sub-panel-title">{{templates.folder}} ({{templates.count}})</div>
          <div style="position: relative;">
            <ngx-flicking
              class="flicking"
              [options]="flickConfig"
              [plugins]="templates.plugins"
              (needPanel)="moreTemplateItems(templates.folder)">
              @for (item of templates.items; track item; let i = $index) {
                <div flicking-panel class="panel" [style.--item-index]="i">
                  <div class="template-wrapper">
                    @switch (templates.folder) {
                      @case ('Background horizontal') {
                        <div>
                          <img alt="" class="imgBGH" [src]="item.url">
                        </div>
                      }
                      @case ('Background vertical') {
                        <div>
                          <img alt="" class="imgBGV" [src]="item.url">
                        </div>
                      }
                      @case ('Vertical') {
                        <div>
                          <img alt="" class="imgV" [src]="item.url">
                        </div>
                      }
                      @default {
                        <div>
                          <img alt="" class="imgH" [ngClass]="{'large': largeCategories.includes(templates.folder)}" [src]="item.url">
                        </div>
                      }
                    }
                    <div class="title d-flex-center">
                      <fa-icon class="mime-type" [icon]="item.mimeType | PipeIcon"></fa-icon>
                      <span>{{item.sceneTitle}}</span>
                    </div>
                    <div class="overlay">
                      <a style="background-color: #0d66c2" mat-icon-button class="mini-button jump-icon" (click)="openImportDialog(item)" matTooltip="{{'general.createSceneFromTemplate' | transloco}}">
                        <mat-icon style="color: white">download</mat-icon>
                      </a>
                    </div>
                  </div>
                </div>
              }
              <span in-viewport class="flicking-arrow-prev">
                <fa-icon size="2xl" [icon]="faArrowLeft"></fa-icon>
              </span>
              <span in-viewport class="flicking-arrow-next">
                <fa-icon size="2xl" [icon]="faArrowRight"></fa-icon>
              </span>
            </ngx-flicking>
          </div>
        </div>
      }
    </div>
  }

